const $ = jQuery.noConflict();
import LazyLoad from './lazyLoad';
import Drops from './drops';

'use strict';
const HardwareAjax = {
	/*-------------------------------------------------------------------------------
		# Cache dom and strings
	-------------------------------------------------------------------------------*/

	$wrapper: $('.js-hardware-wrap'),


	/*-------------------------------------------------------------------------------
		# Initialize
	-------------------------------------------------------------------------------*/
	init: function() {
		this.loadHardware();
	},

	loadHardware: function() {
		$('.js-hardware-load').on('click', function(e) {
			e.preventDefault();

			HardwareAjax.catId = $(this).attr('data-cat');
			HardwareAjax.taxonomy = $(this).attr('data-cat-2');
			HardwareAjax.catName = $(this).attr('data-cat-3');
			console.log(HardwareAjax.catId);

			$.ajax({
				type: 'POST',
				// eslint-disable-next-line no-undef
				url: mongotelAjax.ajaxUrl,
				data: {
					action: 'HardwareAjaxLoad',
					catId: HardwareAjax.catId,
					taxonomy: HardwareAjax.taxonomy,
					catName: HardwareAjax.catName
				},
				success: function(response) {
					const loadMore = document.querySelector('.js-load-more');
					if (response.allPostsCount > response.count) {
						loadMore.classList.remove('hidden');
					} else {
						loadMore.classList.add('hidden');
					}
					$('.js-hardware-wrap').empty();
					$('.js-hardware-wrap-2').empty();
					$('.drops__items-title').empty();
					$(response.htmlPosts).appendTo($('.js-hardware-wrap'));
					$(response.htmlPosts2).appendTo($('.js-hardware-wrap-2'));
					$('.drops__items-title').append('Supported ' + `${response.taxonomy}` + ' - ' + `${response.catName}`);
					Drops.init();
					LazyLoad.init();
				},

			});

		});
	}
};

export default HardwareAjax;
